"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.showToastNotification = void 0;
var core_1 = require("@blueprintjs/core");
var notifications = undefined;
var showToastNotification = function (props) {
    var action = props.action, className = props.className, icon = props.icon, message = props.message, onDismiss = props.onDismiss, timeout = props.timeout, noIcon = props.noIcon;
    var type = props.type;
    type = type || 'none';
    var iconFromType = type === 'success'
        ? 'tick'
        : type === 'warning'
            ? 'warning-sign'
            : type === 'danger'
                ? 'delete'
                : 'blank';
    var iconfx = icon || iconFromType;
    var ToastProps = __assign({ message: message, onDismiss: onDismiss, action: action, className: className, intent: type, timeout: timeout || 3000 }, ((!noIcon || iconfx !== 'blank') && { icon: iconfx }));
    if (!notifications) {
        notifications = core_1.Toaster.create({
            className: className,
            canEscapeKeyClear: true,
            position: 'top-right'
        });
    }
    notifications.show(ToastProps);
};
exports.showToastNotification = showToastNotification;
